import {
  dialogTranslations,
  DialogTranslations,
} from '@/assets/locales/components/dialog/dialog.translations.en';
import {
  notificationsTranslations,
  NotificationsTranslations,
} from '@/assets/locales/components/notifications/notifications.translations.en.ts';
import {
  tableTranslations,
  TableTranslations,
} from '@/assets/locales/components/table/table.translations.en';
import { formTranslation, FormTranslation } from '@/assets/locales/form/form.translation.en';

import {
  loaderWithInterestingFactsAboutAITranslations,
  LoaderWithInterestingFactsAboutAITranslations,
} from './loaderWithInterestingFactsAboutAI/loaderWithInterestingFactsAboutAI.translations.en';

export type ComponentsTranslation = {
  chat: {
    documents: {
      attach: string;
      delete: string;
      deleteDialog: {
        cancel: string;
        confirm: string;
        message: string;
        title: string;
      };
      download: string;
      dropOverlay: string;
      dropzoneHintPrefix: string;
      dropzoneLabel: string;
      dropzoneMaxSize: string;
      embeddingStatus: {
        available: string;
        failed: string;
        noContent: string;
        processing: string;
      };
      empty: string;
      hint: string;
      source: { activity: string; admin: string };
      title: string;
    };
    genericChatMessageBubble: {
      aiMessageHeader: string;
      userMessageHeader: string;
    };
  };
  dialog: DialogTranslations;
  form: FormTranslation;
  guidedJourney: {
    close: string;
    dontShowAgain: string;
  };
  loaderWithInterestingFactsAboutAI: LoaderWithInterestingFactsAboutAITranslations;
  notifications: NotificationsTranslations;
  table: TableTranslations;
};

export const componentsTranslation: ComponentsTranslation = {
  chat: {
    documents: {
      attach: 'Attach document',
      delete: 'Delete',
      deleteDialog: {
        cancel: 'Cancel',
        confirm: 'Delete document',
        message:
          'Are you sure you want to remove this document from the chat? This cannot be undone.',
        title: 'Delete document',
      },
      download: 'Download',
      dropOverlay: 'Drop the file to upload it',
      dropzoneHintPrefix: 'Accepted: PDF, DOCX, XLSX, TXT · max',
      dropzoneLabel: 'Drag a file here or click to upload',
      dropzoneMaxSize: '20 MB / file',
      embeddingStatus: {
        available: 'Available in chat',
        failed: 'Processing error',
        noContent: 'No extractable content',
        processing: 'Processing…',
      },
      empty: 'No documents yet',
      hint: 'The assistant can use their content in this conversation.',
      source: {
        activity: 'Development activity',
        admin: 'Administrator material',
      },
      title: 'Documents in this chat',
    },
    genericChatMessageBubble: {
      aiMessageHeader: 'jAIn',
      userMessageHeader: 'Me',
    },
  },
  dialog: dialogTranslations,
  form: formTranslation,
  guidedJourney: {
    close: 'Close for now',
    dontShowAgain: "Don't show this again",
  },
  loaderWithInterestingFactsAboutAI: loaderWithInterestingFactsAboutAITranslations,
  notifications: notificationsTranslations,
  table: tableTranslations,
};
